<template>
    <div class="section">
        <h2 class="subtitle is-size-4">{{$t('users.account.avatar.title')}}</h2>

        <form @submit.prevent="submit">
            <template v-if="avatar && preview">
                <figure class="image">
                    <img :src="preview">
                </figure>

                <p class="help">{{$t('users.account.avatar.newImage')}}</p>
            </template>

            <template v-else>
                <avatar :account="currentUserAccount" :size="150" />

                <p class="help">{{$t('users.account.avatar.currentImage')}}</p>
            </template>

            <br>

            <b-notification v-if="error" :active.sync="error" type="is-danger">
                <p>{{error}}</p>
            </b-notification>

            <b-notification v-if="success" :active.sync="success" type="is-success" :closable="false">
                <p>{{success}}</p>
            </b-notification>

            <template v-else>
                <b-field class="file" :loading="isUploading">
                    <b-upload v-model="avatar" @input="setPreview" accept="image/jpeg,image/png" >
                        <a class="button">
                            {{$t('global.actions.select')}}
                        </a>
                    </b-upload>

                    <span class="file-name" v-if="avatar">{{ avatar.name }}</span>

                    <button v-if="avatar" type="submit" class="button submit is-primary" :class="{'is-loading': isUploading}">
                        <b-icon icon="upload" />
                        <span>{{$t('global.actions.update')}}</span>
                    </button>
                </b-field>

                <p class="help">{{$t('users.account.avatar.requirementsHelp')}}</p>
            </template>
        </form>
    </div>
</template>

<style lang="scss" scoped>
    .image img {
        height: 150px;
        width: 150px;
    }

    .file .button.submit {
        margin-left: 15px;
    }
</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import UserService from '@/taskflex/users/services/UserService';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                avatar: null,
                error: null,
                success: null,
                isUploading: false,
                preview: null,
            };
        },

        computed: {
            ...mapGetters('auth', [
                'currentUser',
                'currentUserAccount',
            ]),
        },

        methods: {
            setPreview() {
                const file = this.avatar;

                if (file) {
                    const reader = new FileReader();

                    reader.addEventListener('load', () => {
                        this.preview = reader.result;
                    }, false);

                    reader.readAsDataURL(file);
                }
            },

            async submit() {
                this.isUploading = true;

                const options = new FormData();
                options.append('avatar', this.avatar);

                UserService.avatar(this.currentUser.id, options, () => {
                    this.success = this.$t('users.account.avatar.uploadSuccess');
                    this.isUploading = false;
                }, () => {
                    this.error = this.$t('users.account.avatar.uploadError');
                    this.isUploading = false;
                });
            },
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/users/components/UserAvatarEditingArea.vue